import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useNavigateToChannelDetail = () => {
  const navigate = useNavigate();

  return useCallback(
    async (id: string) => {
      await navigate(routes.channels.customChannelDetail(id));
    },
    [navigate],
  );
};
